import type { CSSProperties } from 'react';

export interface HairlineProps {
  className?: string;
  style?: CSSProperties;
}

export function Hairline({ className, style }: HairlineProps) {
  return (
    <div
      className={['h-px bg-border', className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
}
